module.exports = "<app-home-living-pnw></app-home-living-pnw>\n<app-home-engineering-coding></app-home-engineering-coding>\n"


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main